function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import map from 'lodash/map';
import FormGroup from 'components/Form/FormGroup';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import App from 'modules/App';
import styles from '../Boxes.pcss';
var _React_PureComponent;
class Country extends (_React_PureComponent = React.PureComponent) {
    get countryOptions() {
        return this.props.countries.map((country)=>({
                value: country.alpha2Code,
                label: get(this.props.localizationResources, [
                    country.nameKey,
                    'value'
                ], country.englishName)
            })).sort((a, b)=>a.label.localeCompare(b.label));
    }
    renderCountryBox(countryOption) {
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "alpha2Code",
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                inputValue: countryOption.value,
                labelMessage: countryOption.label,
                isRadio: true,
                onChange: this.props.onSetFormValue
            })
        }, countryOption.value);
    }
    render() {
        return map(this.countryOptions, (countryOption)=>this.renderCountryBox(countryOption));
    }
}
_define_property(Country, "propTypes", {
    countries: PropTypes.arrayOf(App.shapes.country),
    formValues: PropTypes.object,
    onSetFormValue: PropTypes.func,
    // Implicit props
    localizationResources: PropTypes.object
});
_define_property(Country, "defaultProps", {
    countries: []
});
const mapStateToProps = ()=>(state)=>({
            localizationResources: App.selectors.localizationResources(state)
        });
const ConnectedCountry = connect(mapStateToProps)(Country);
export default withStyles(styles)(ConnectedCountry);
